module.exports = __webpack_public_path__ + "static/media/na.c65a370f.svg";